import styled, { keyframes } from 'styled-components';
import fonts from 'styles/fonts';
import colors from 'styles/colors';
import media from 'styles/media';
import { FILTERS_MODAL } from 'components/Scroller/constants';

export const Underlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  height: 100vh;
  width: 100vw;
  /* background-color: ${colors.primary.ice}; */
  background: linear-gradient(180deg, ${colors.primary.ice} 0%, #ebedf0 100%);
  z-index: 1;

  opacity: 0;
  pointer-events: none;

  transition: opacity 0.2s cubic-bezier(0, 0, 0, 0);

  &.show {
    opacity: 1;
    pointer-events: initial;
  }
`;

export const Wrapper = styled.div`
  position: relative;
  width: 100%;
  ${props => props.scrollerId === FILTERS_MODAL && 'margin-bottom: 25px;'}
  z-index: 1;

  ${media.small`
	${props => props.scrollerId === FILTERS_MODAL && 'margin-bottom: 20px;'}
  `}
`;

export const InputWrapper = styled.div`
  height: 60px;
  padding: 0 60px 0 20px;
  display: flex;
  align-items: center;
  border-radius: 5px 5px 5px 5px;
  border: 1.5px solid ${colors.secondary.deepCove};

  .focus & {
    border: 1.5px solid ${colors.primary.ocean};
  }

  .open & {
    border-radius: 5px 5px 0 0;
    border: 1.5px solid ${colors.primary.ocean};
  }

  ${media.small`
    .open & {
      border-radius: 5px;
      border: 1.5px solid ${colors.primary.ocean};
    }
  `}
`;

export const Input = styled.input`
  font-family: ${fonts.primary.regular};
  font-size: 20px;
  line-height: 24px;
  color: ${colors.functional.black};
  outline: none;
  background-color: unset;
  border: none;
  width: 100%;

  &::placeholder {
    color: ${colors.secondary.deepCoveVeryLight};
  }
`;

export const SuggestionsWrapper = styled.div`
  position: absolute;
  top: 100%;
  width: 100%;
  padding: 0 20px 0;
  background-color: ${colors.primary.ice};
  border-radius: 0 0 5px 5px;
  z-index: 1;

  max-height: 432px;
  overflow-y: scroll;
  overflow-x: hidden;

  .open & {
    border-left: 1px solid #6a739a;
    border-right: 1px solid #6a739a;
    border-bottom: 1px solid #6a739a;
  }

  ${media.small`
    .open & {
      border: unset !important;
      padding-bottom: 50px;
      background: unset;
    }

    padding: 0;
    max-height: calc(100vh - 130px);
  `}
`;

const suggestionIn = keyframes`
  0% {
    opacity: 0;
    transform: translateY(7px);
  } 100% {
    opacity: 1;
    transform: translateY(0);
  }
`;

export const Suggestion = styled.button`
  margin: 0;
  padding: 0;
  display: block;
  font-family: ${fonts.primary.bold};
  font-size: 20px;
  color: ${colors.primary.ocean};
  opacity: 0;
  transform: translateY(7px);
  animation: ${suggestionIn} 0.2s ${props => props.index * 0.03}s
    cubic-bezier(0, 0, 0, 0) forwards;
  transition: color 0.2s cubic-bezier(0, 0, 0, 0);
  text-align: left;
  outline-offset: 5px;

  &:hover,
  &:active,
  &:focus {
    color: ${colors.secondary.deepCove};
  }

  &:first-child {
    margin-top: 20px;
  }
  &:not(:last-child) {
    margin-bottom: 28px;
  }
  &:last-child {
    margin-bottom: 20px;
  }
  &.disabled {
    pointer-events: none;
    color: rgba(120, 122, 126, 0.5);
  }
`;

export const ExplanatoryText = styled.span`
  font-family: ${fonts.primary.regular};
  font-size: 20px;
  color: ${colors.primary.ocean};
`;

export const SearchIconWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;

  position: absolute;
  top: 50%;
  right: 25px;
  transform: translateY(-50%);

  height: 18px;
  width: 18px;

  svg {
    transition: transform 0.15s cubic-bezier(0, 0, 0, 0);
  }

  &.show {
    svg {
      transform: scale(1);
    }
  }

  &.hide {
    svg {
      transform: scale(0);
    }
  }
`;

export const CloseButton = styled.button`
  padding: 0;
  margin: 0;
  display: flex;
  align-items: center;
  justify-content: center;

  position: absolute;
  top: 23px;
  right: 25px;

  height: 18px;
  width: 18px;

  svg {
    transition: transform 0.15s cubic-bezier(0, 0, 0, 0);
  }

  path {
    transition: stroke 0.15s cubic-bezier(0, 0, 0, 0);
  }

  &.show {
    svg {
      transform: scale(1);
    }
  }

  &.hide {
    pointer-events: none;
    svg {
      transform: scale(0);
    }
  }

  &:hover {
    path {
      stroke: ${colors.primary.ocean};
    }
  }
`;
